export default __webpack_public_path__ + "b854e0b01247a7831a501857e8e731e3.svg";